module.exports = __webpack_public_path__ + "img/logo_for_invoice.fdd3f27b.png";